import { render } from "./Perks.vue?vue&type=template&id=60aaa12d"
import script from "./Perks.vue?vue&type=script&lang=js"
export * from "./Perks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__